import * as React from "react";
import { Box } from "@mui/material";
import ReactPlayer from "react-player";
import "./style.css";
import { useTracking } from "react-tracking";
import { useDebounce } from "../../hooks/useDebounce";

const toYoutubeEmbedUrl = (urlString) => {
    if (!urlString) return "";
    try {
        const parsed = new URL(urlString);
        const isWsbEmbed = parsed.hostname?.includes("wsb.com") && parsed.pathname?.includes("/videoembed/");
        if (!isWsbEmbed) return urlString;

        const id = parsed.searchParams.get("id");
        if (!id) return urlString;

        const params = new URLSearchParams({
            autoplay: "0",
            modestbranding: "1",
            rel: "0",
            enablejsapi: "1",
        });

        if (parsed.searchParams.get("start")) {
            params.set("start", parsed.searchParams.get("start"));
        }
        if (parsed.searchParams.get("end")) {
            params.set("end", parsed.searchParams.get("end"));
        }

        return `https://www.youtube.com/embed/${id}?${params.toString()}`;
    } catch (error) {
        return urlString;
    }
};

const TrackedReactPlayer = ({ item, trackBase, disableTracking, record, shared, userDetails, sessionId }) => {
    const { trackEvent } = useTracking();
    const ref = React.useRef(null);

    const [trackingData, setTrackingData] = React.useState({});

    const handleVideoEvent = (name, eventData, item) => {
        console.log(name, eventData, item);

        let data = {
            ...trackBase,
            action: "video-click",
            type: "speaker-sidebar",
            customSave: true,
            id: item.videoId + "-" + sessionId,
            videoId: item.videoId,
            description:
                `Started watching ${item.videoName}` +
                (shared || userDetails?.userType === "anonymous" ? " from Share Link" : ""),
            videoDetails: {
                videoDescription: item.videoDescription,
                videoId: item.videoId,
                videoName: item.videoName,
                videoURL: item.videoURL,
                playData: [],
                videoDuration: ref.current?.getDuration?.(),
            },
        };

        if (!data.parentId) {
            data.parentId = item.videoId;
        }
        let save = false;
        if (name === "onStart") {
            save = true;
        } else if (name === "onPause") {
            save = true;
            if (trackingData?.videoDetails?.playData) {
                data.videoDetails.playData = trackingData?.videoDetails?.playData;
            }
            data.videoDetails.playData = [...data.videoDetails.playData, "Pause"];
        } else if (name === "onProgress") {
            if (eventData?.loadedSeconds > 0) {
                save = true;
                if (trackingData?.videoDetails?.playData) {
                    data.videoDetails.playData = trackingData?.videoDetails?.playData;
                }
                data.videoDetails.playData = [...data.videoDetails.playData, Math.floor(eventData.playedSeconds)];
            }
        }
        if (save) {
            if (data.videoDetails.playData.length > 15) {
                trackEvent(data);
                data.videoDetails.playData = [];
            } else {
                callTrackEvent(data);
            }
        }
        setTrackingData(data);
    };

    const callTrackEvent = useDebounce((data) => {
        trackEvent(data);
    }, 2.5 * 1000);

    const videoUrl = toYoutubeEmbedUrl(item.videoURL);

    return (
        <ReactPlayer
            ref={ref}
            width="100%"
            height="100%"
            className="react-player"
            url={videoUrl}
            controls={true}
            onStart={(eventData) => handleVideoEvent("onStart", eventData, item)}
            onPause={(eventData) => handleVideoEvent("onPause", eventData, item)}
            onProgress={(eventData) => handleVideoEvent("onProgress", eventData, item)}
        />
    );
};

export { TrackedReactPlayer };
